export default {"hero":"MvwO8","title":"_-6KAj","subTitle":"_5gWzK"};